<div [formGroup]="form"
     class="builder-container"
     [ngClass]="'level-' + level">

  <!-- LIVE PREVIEW AT TOP -->
  <!-- <div class="logic-preview-top">
    <mat-icon>visibility</mat-icon>
    <span>{{ readableLogic }}</span>
  </div> -->

  <mat-expansion-panel [expanded]="true" class="group-panel">

    <mat-expansion-panel-header>

      <mat-panel-title class="group-title">
        <span class="group-label">Group</span>

        <div class="stop-click">
          <mat-form-field appearance="outline" class="group-condition">
            <mat-select
              formControlName="condition"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()">
              <mat-option *ngFor="let g of groupOperators" [value]="g">
                {{ g }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-panel-title>

      <mat-panel-description>
        <button mat-icon-button color="primary"
          (click)="addRule(form); $event.stopPropagation()"
          matTooltip="Add Rule">
          <mat-icon>add</mat-icon>
        </button>

        <button mat-icon-button color="accent"
          (click)="addGroup(form); $event.stopPropagation()"
          matTooltip="Add Group">
          <mat-icon>account_tree</mat-icon>
        </button>
      </mat-panel-description>

    </mat-expansion-panel-header>

    <div formArrayName="rules" class="rules-container">

      <div *ngFor="let rule of getRulesArray(form).controls; let i=index">

        <!-- SIMPLE RULE -->
        <div *ngIf="!isGroup(rule)" [formGroupName]="i" class="rule simple-rule">
          <mat-form-field appearance="outline">
          <mat-label i18n="@@targetloginusername">
              Select Field
          </mat-label>
          <mat-select formControlName="metric_id"
                      (selectionChange)="onFieldChange($event.value, rule)">
            <mat-option *ngFor="let f of fields" [value]="f.metric_id">
              {{ f.fieldName }}
            </mat-option>
          </mat-select>
        <mat-error *ngIf="rule.get('metric_id')?.hasError('required')">
          Field is required
        </mat-error>
          </mat-form-field>


          <mat-form-field appearance="outline" class="operator">
            <mat-label i18n="@@targetloginusername">
              Select Operator
            </mat-label>
            <mat-select formControlName="operator">
              <mat-option *ngFor="let op of operators" [value]="op.value">{{ op.label }}</mat-option>
            </mat-select>
        <mat-error *ngIf="rule.get('operator')?.hasError('required')">
          Operator is required
        </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
          <mat-label i18n="@@targetloginusername">
              Enter Value
            </mat-label>  
            <input matInput formControlName="value">
                  <mat-error *ngIf="rule.get('value')?.hasError('specialCharacter')">
                Special characters are not allowed
              </mat-error>
        <mat-error *ngIf="rule.get('value')?.hasError('required')">
          Value is required
        </mat-error>
          </mat-form-field>

          <button mat-icon-button color="warn" style="margin-bottom: auto;"
            (click)="removeRule(form,i)" matTooltip="Delete Rule">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <!-- NESTED GROUP -->
        <div *ngIf="isGroup(rule)" [formGroupName]="i" class="nested-group">
          <app-expression-builder
          [form]="rule"
            [fields]="fields"
            [operators]="operators"
            [groupOperators]="groupOperators"
            [level]="level + 1"
           (expressionChange)="onChildExpressionChange(i, $event)">
          </app-expression-builder>

          <button mat-icon-button color="warn"
            (click)="removeRule(form,i)" matTooltip="Delete Group">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
    </div>

  </mat-expansion-panel>
</div>
